// extracted by mini-css-extract-plugin
export var animationContainer = "_ga-0";
export var asteriskIcon = "_ga-8";
export var conversationLeftSection = "_ga-4";
export var conversationListItem = "_ga-3";
export var conversationMiddleSection = "_ga-5";
export var conversationRightSection = "_ga-6";
export var detailsContent = "_ga-1";
export var listContainer = "_ga-7";
export var modalContent = "_ga-2";